var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('simple-page',{attrs:{"title":_vm.title,"sections":_vm.sections}})
}
var staticRenderFns = []

export { render, staticRenderFns }